import React from 'react';

interface Router {
    redirect: (route: any) => void;
    route: any;
}

const RouterContext = React.createContext<Router>(null as never);

interface RouterProviderProps {
    initialRoute: any;
    children: React.ReactNode;
}

export const RouterProvider: React.FC<RouterProviderProps> = (props) => {
    const [route, redirect] = React.useState<any>(props.initialRoute);

    const context = React.useMemo(
        () => ({ redirect, route }),
        [redirect, route],
    );

    return (
        <RouterContext.Provider value={context}>
            {props.children}
        </RouterContext.Provider>
    );
};

function renderRoute({ Component, props }: any) {
    return (
        <Component {...props} />
    );
}

export const Route: React.FC = () => {
    const { route } = React.useContext(RouterContext);

    return renderRoute(route);
};

export const useRedirect = () => {
    return React.useContext(RouterContext).redirect;
};
